import { render, staticRenderFns } from "./promotion-viewer-name-date-wrapper.vue?vue&type=template&id=2d7c702c&scoped=true"
import script from "./promotion-viewer-name-date-wrapper.vue?vue&type=script&lang=js"
export * from "./promotion-viewer-name-date-wrapper.vue?vue&type=script&lang=js"
import style0 from "./promotion-viewer-name-date-wrapper.vue?vue&type=style&index=0&id=2d7c702c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d7c702c",
  null
  
)

export default component.exports